<script setup lang="ts">
import { ref, watch, onMounted, onBeforeUnmount } from "vue";
import Icon from "./Icon.vue";
import { createChatScroll } from "../composables/chatScroll";
const props = defineProps<{ conversationKey: string }>();
const emit = defineEmits<{ backgroundMenu: [event: MouseEvent] }>();
const viewport = ref<HTMLElement>(),
  content = ref<HTMLElement>(),
  ready = ref(false),
  away = ref(false);
const scrolling = createChatScroll(
  () => viewport.value,
  (value) => {
    away.value = value;
  },
);
let observer: ResizeObserver | undefined;
function open() {
  scrolling.open();
  ready.value = true;
}
watch(() => props.conversationKey, open, { flush: "post" });
onMounted(() => {
  open();
  observer = new ResizeObserver(scrolling.onResize);
  if (viewport.value) observer.observe(viewport.value);
  if (content.value) observer.observe(content.value);
});
onBeforeUnmount(() => observer?.disconnect());
defineExpose({ scrollToEnd: scrolling.toEnd });
</script>
<template>
  <div class="chat-viewport" :data-scroll-ready="ready">
    <div
      ref="viewport"
      class="message-scroll scroll"
      :style="{ visibility: ready ? undefined : 'hidden' }"
      @scroll="scrolling.onScroll"
      @contextmenu.self.prevent="emit('backgroundMenu', $event)"
    >
      <div
        ref="content"
        class="message-content"
        @contextmenu.self.prevent="emit('backgroundMenu', $event)"
      >
        <slot />
      </div>
    </div>
    <button
      v-if="away"
      class="jump-bottom"
      aria-label="Ir para mensagens recentes"
      @click="scrolling.toEnd"
    >
      <Icon name="down" />
    </button>
  </div>
</template>
